/**
 * Abrir «Apariencia» desde cualquier lugar del panel (el menú de la cuenta, el de Chats).
 *
 * ⭐ UN EVENTO Y NO UN IMPORT DEL MODAL: quien abre no carga el modal ni Polaris por su cuenta, y el modal
 *    vive en su propia raíz (montarApariencia.tsx), fuera del árbol de la app. Este archivo no importa nada.
 */
export const EVENTO_APARIENCIA = 'smarty:abrir-apariencia';

export function abrirApariencia(): void {
  window.dispatchEvent(new Event(EVENTO_APARIENCIA));
}
